import { createFileRoute } from '@tanstack/react-router';

import { preloadRegisteredApps } from 'hooks/useQuery/useQueryRegisteredApps';

import { FavoritesView } from 'views/FavoritesView';

export const Route = createFileRoute('/_auth/_buttonView/_layout/favorites/$id')({
  beforeLoad: async ({ context, params }) => {
    const [appRegistration] = await preloadRegisteredApps(context.queryClient, params?.id);

    if (appRegistration !== undefined) {
      context.hideButtonBarButtons = ['retain', 'resource-promote', 'resource-sell', 'search', 'directory'];
    } else {
      context.hideButtonBarButtons = ['search'];
    }

    return context;
  },
  component: FavoritesView,
});
